module.exports = __webpack_public_path__ + "static/media/icon_view_off.e56dcc91.svg";